import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import image4 from "../../../images/financial/cybersecurity1.webp";
import Bannerimg from "../../../images/financial/financial1.webp";
import image3 from "../../../images/financial/financial4.webp";
import image5 from "../../../images/financial/offerings2.webp";
import image1 from "../../../images/financial/retail1.webp";
import image2 from "../../../images/financial/retail4.webp";

const FinancialServices = () => {
  const banner = {
    title: "Financial Services    ",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Retail & Wholesale Banking",
      description:
        "Cylon Technologies understand the intricacies of wholesale and retail banking that is why we offer tailored banking services and solutions across various lines of businesses so that you can grow and run your businesses effectively and efficiently. Our team has extensive banking experience with multiple lines of businesses having served global banks across geographies.",
      tagName: "Learn More",
      tagLink: "retail-wholesale-banking",
    },
    {
      image: image2,
      title: "Investment, Banking & Brokerage      ",
      description:
        "Cylon Technologies understand the intricacies of wholesale and retail banking that is why we offer tailored banking services and solutions across various lines of businesses so that you can grow and run your businesses effectively and efficiently. Our team has extensive banking experience with multiple lines of businesses having served global banks across geographies.",
      tagName: "Learn More",
      tagLink: "investment-banking-and-brokerage",
    },
    {
      image: image3,
      title: "Cards",
      description:
        "Financial institutions/banks thrive on meeting the needs of their commercial/retail customers while providing them with exceptional client experiences.  With the global cards and payments industry, witnessing a diminishing trend in traditional banking and constantly progressing towards emerging digital technologies.",
      tagName: "Learn More",
      tagLink: "cards",
    },
    {
      image: image4,
      title: "Risk & Compliance",
      description:
        "Risk is inevitable and unpredictable in enterprises and as such Risk Management and Compliance Services from Cylon Technologies that help you in evaluating your existing security governance across businesses and technologies. We have expertise in identifying the interactions between the risks that influence your business.",
      tagName: "Learn More",
      tagLink: "risk-and-compliance",
    },
    {
      image: image5,
      title: "Digital Transformation",
      description:
        "Digital Transformation involves achieving digital excellence that enables you in focussing your whole value chain for the best customer experience and operational performance especially when Social, Mobile, Analytics, and Cloud (SMAC) are constantly reshaping and levelling the playfield.",
      tagName: "Learn More",
      tagLink: "digital-transformation",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Financial Services — Cylon Technologies – Big Data | Data Analytics |
          Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content pb-5">
        <div className="container">
          <h2 className="heading2 text-center pb-4">Financial Services</h2>
          <p>
            In an exceptionally managed and focused business sector, banks
            require each point of interest to surpass client desires and
            differentiate. It is not sufficient any more to offer
            straightforward and computerized Banking administrations.
          </p>
          <p>
            Keeping in mind the end goal to manufacture unwaveringness and drive
            benefit, banks should offer a constant intelligent Banking
            environment. To accomplish this, banks need to build their business
            readiness by foreseeing client needs and offer a connecting with
            client experience.{" "}
          </p>
          <p>
            Cylon Technologies lets you transform your products, services and
            processes to make you customer friendly. We increase your efficiency
            multifold and reduce risk incurred. We cover:
          </p>
          <div className="col-md-10 mx-auto">
            <div className="row g-md-5 g-4">
              {card.map((item, index) => (
                <div className="col-md-6" key={index}>
                  <div className="img_card">
                    <img src={item.image} alt="images" />
                    <h2 className="heading2">{item.title}</h2>
                    <p>{item.description}</p>

                    {item.tagName && item.tagLink && (
                      <div className="btn_spacet">
                        <a
                          href={item.tagLink}
                          className="btn_small outline_blue"
                        >
                          {item.tagName}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center pt-5">
              <Link
                to="/connect"
                className="btn_custom blue_btn"
                href="Inquire"
              >
                Inquire
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinancialServices;
